// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Af1J","col":"styles_col__3NcuH"};